import {
    Title,
    CurrencySymbol,
    PriceRow,
    PriceTerm,
    PriceWrapper,
    DarkSection,
    WrapperButton,
} from "./Price.styles";

import Button from "../Button";

interface PriceTagProps {
    value: string;
}

export function PriceTag({ value }: PriceTagProps) {
    return (
        <DarkSection>
            <PriceWrapper>
                <PriceRow>
                    <CurrencySymbol $mt={8}>R$</CurrencySymbol>
                    <Title>{value}</Title>
                    <PriceTerm>mensal</PriceTerm>
                </PriceRow>

                {/* <SetupText>
                    <SetupTitle>Setup Inicial</SetupTitle>
                    <MoneyGroup>
                        <CurrencySymbol $size={14} $mt={4}>R$</CurrencySymbol>
                        <Title $size={24} $ml={2}>{formattedSetupFee}</Title>
                    </MoneyGroup>
                </SetupText> */}
            </PriceWrapper>

            <WrapperButton>
                <Button style={{color: "#000"}} onClick={() => {window.location.href = '/redirect'}}>ASSINAR</Button>
            </WrapperButton>
        </DarkSection>
    );
}
